import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MarsAndVenusBurst = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M504 0c-9.7 0-18.5 5.8-22.2 14.8S480.1 34.1 487 41l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160 0 80.2 59.1 146.7 136.1 158.2 0 .6-.1 1.2-.1 1.8V407.8h-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h24V487.7h24-24c0 13.3 10.7 24 24 24s24-10.7 24-24h-24 24V484.7v.3V483.9v.1V473.9v.1V469.6v.4V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24V387.8v.2V384c0-.6 0-1.2-.1-1.8 77-11.6 136.1-78 136.1-158.2 0-31.4-9-60.7-24.7-85.4l24.7-24.7 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 320c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74-76.1-23.2c-6.3-1.9-13.1.2-17.2 5.3S33.8 86.4 37 92.1l39.5 69.1-65.6 45.2c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.5c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l58.6-53.8 58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2l-60.1 18.3-29.4-74z"
  }));
});
MarsAndVenusBurst.displayName = 'MarsAndVenusBurst';
export var MarsAndVenusBurstDimensions = {
  height: 512,
  width: 640
};